import React, { useEffect, useMemo, useState } from 'react';
import { Box, Typography, TextField, Paper, Button } from '@mui/material';
import { adminApi } from '../api';

export default function EmbedPage() {
  const [publicUrl, setPublicUrl] = useState(process.env.REACT_APP_PUBLIC_URL || 'http://localhost:3000');

  useEffect(() => {
    adminApi.getSettings().then((data) => {
      if (data.embedPublicUrl) setPublicUrl(data.embedPublicUrl);
    }).catch(() => {});
  }, []);

  const snippet = useMemo(() => {
    const src = `${publicUrl.replace(/\/$/, '')}?embed=1`;
    return `<!-- Widget chatbot -->
<button id="chat-fab" aria-label="Apri chat">Chat</button>
<div id="chat-container" style="display:none;position:fixed;bottom:96px;right:24px;width:440px;height:680px;z-index:8999;">
  <iframe src="${src}" allow="microphone" title="Chatbot" style="width:100%;height:100%;border:none;"></iframe>
</div>
<script>
  const fab = document.getElementById('chat-fab');
  const box = document.getElementById('chat-container');
  fab.addEventListener('click', () => {
    box.style.display = box.style.display === 'block' ? 'none' : 'block';
  });
</script>`;
  }, [publicUrl]);

  const copy = async () => {
    await navigator.clipboard.writeText(snippet);
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
        Codice embed
      </Typography>
      <TextField
        label="URL pubblico del frontend"
        value={publicUrl}
        onChange={(e) => setPublicUrl(e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />
      <Button variant="outlined" onClick={copy} sx={{ mb: 2 }}>
        Copia snippet
      </Button>
      <Paper sx={{ p: 2, bgcolor: '#111', color: '#d6ffd6', overflow: 'auto' }}>
        <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{snippet}</pre>
      </Paper>
    </Box>
  );
}
